const binarySearch = (length, callback) => {
  let low = 0;
  let high = length - 1;
  let best = -1;
  let mid;

  while (low <= high) {
    mid = Math.floor((low + high) / 2);
    const result = callback(mid);
    if (result < 0) {
      high = mid - 1;
    } else if (result > 0) {
      low = mid + 1;
    } else {
      best = mid;
      low = mid + 1;
    }
  }
  return best;
};

const isTextOverflowing = element => {
  const currentOverflow = element.style.overflow;
  if (!currentOverflow || currentOverflow === "visible") {
    element.style.overflow = "hidden";
  }

  const isOverflowing = element.scrollHeight - element.clientHeight > 3;
  element.style.overflow = currentOverflow;
  return isOverflowing;
};

export default container => {
  const content = container;
  const text = content.textContent;
  if (isTextOverflowing(container)) {
    const checkFunc = i => {
      content.innerText = text.substring(0, i);
      return isTextOverflowing(container) ? -1 : 0;
    };
    const len = binarySearch(text.length - 1, checkFunc);
    content.textContent = `${text.substring(0, len).slice(0, -3)}...`;
  }
};
